import React,{Component} from 'react';
import moment from 'moment';
import PedidoDetalle from './PedidoDetalle';
import _ from 'lodash';
// <I 86111> ivelasquez 12/03/2021
import xml from "../../../images/xml-v2.png";
import pdf from "../../../images/pdf-v2.png";
import saveAs from "../../../utils/downloadFile";
import Modal from "../../../components/Modal";
import {FadeLoader} from 'react-spinners';
import ReactPaginate from "react-paginate";
import connect from "react-redux/es/connect/connect";
import {fetchDetalleFacturas, fetchDocumentoDescargar, postInmatriculacionCorreo} from "../../../actions";
import {WithContext as ReactTags} from "react-tag-input";
import {displayValidationErrors, isFormValid} from "../../../utils/validateForm";
import correoValidators from "../../Inmatriculacion/correoValidators";
import Alert from "../../../components/Alert";
// <F 86111> ivelasquez 12/03/2021
const TablaTd = rows =>

    rows.row.detalle===null || rows.row.detalle===undefined?[]:rows.row.detalle.map((row, i) =>
        <td key={i}>
            <p><span className='c-cyan'>{row.noFactu}</span><br /><span>${row.valPreDocu}</span><br /><span>{moment(row.fecha).format('DD/MM/YYYY')}</span></p>
        </td>
    );
// <I 86111> ivelasquez 12/03/2021
const TablaTdEmpty = (props) => {
    const arr = []
    const pedidos = props.pedidos
    const row = props.row
    const num = _.max(pedidos.map(x => x.detalle ===null || x.detalle ===undefined ? 0 : x.detalle.length))

    for (var i = 0; i < num - (row.detalle ===null || row.detalle ===undefined ? 0 : row.detalle.length); i++) {
        arr.push(i + 1)
    }

    return arr.map((row) =>
        <td key={row}></td>
    );
}
// <F 86111> ivelasquez 12/03/2021

const TablaTr = (props) => {
    const pedidos = props.pedidos;
    if (_.isArray(pedidos)) {
        return props.pedidos.map(row =>

            <tr key={row.numPedidoVeh}>
                {console.log('row.detalle',row.detalle)}
                <td>
                    <div className='checkbox checkbox-inline'>
                        <label htmlFor={`${row.numPedidoVeh}-facturacion`}>
                            <input
                                type='checkbox'
                                checked={props.pedidosConCheck.indexOf(row.numPedidoVeh)>=0}
                                onChange={() => props.selectCheckPedidos(row.numPedidoVeh)}
                                id={`${row.numPedidoVeh}-facturacion`}
                            />
                            <div className='checkbox-skin' />
                        </label>
                    </div>
                </td>
                <td><button className='btn btn-iconLeft btn-link' data-dismiss='modal' data-toggle='modal' data-target='#fdv-detalle'  onClick={() => props.fnSelectPedido(row.numPedidoVeh)} ><i/><span>{row.numPedidoVeh}</span></button></td>
                <td>{row.numChasis}</td>
				<td>{row.tipoSolFact}</td>
                <td style={{width:150}}>{row.detalle!==null && row.detalle!==undefined?row.detalle.length>0?(<span className='pill pill-block pill-yellow'>{row.detalle[0].desEstadoCancela}</span>):null:null}</td>
                <td>{row.desClie}</td>
                <td>{row.desPropietarioVeh}</td>
                <td>{row.desUsuarioVeh}</td>
                <TablaTd row={row} />
                {/* <I 86111> ivelasquez 12/03/2021 */}
                <TablaTdEmpty row={row} pedidos={props.pedidos} />
                <td>
                    <div className='dropdown kebab customToggle' role='group'>
                        <button className='btn dropdown-toggle kebab-btn pull-right'
                                name={'btnDropdownToggle'}><i
                            className='ion-android-more-vertical' name={'iconDropdownToggle'}/>
                        </button>
                        {
                            <ul className='dropdown-menu dropdown-menu-right'>
                                <li key={'DETALLE'}><a
                                    onClick={() => {
                                        props.fnSelectPedidoModal(row, 'ver-facturas')
                                    }}><i
                                    className='ion-eye c-cyan'/><span>Ver Facturas</span></a>
                                </li>
                                <li key={'CORREO'}><a
                                    onClick={() => {
                                        props.fnSelectPedidoModal(row, 'enviar-correo')
                                    }}><i
                                    className='ion-calendar c-cyan'/><span>Enviar Correo</span></a>
                                </li>
                            </ul>
                        }
                    </div>
                </td>
                {/* <F 86111> ivelasquez 12/03/2021 */}
            </tr>
        );
    }
    return null;
};

const TablaTh = (props) => {
    const pedidos = props.pedidos;
    console.log('pedidos',pedidos);
    if (_.isArray(pedidos)) {
        return _.times(_.max(pedidos.map(x => x.detalle ===null || x.detalle ===undefined ?0:x.detalle.length)), String).map((row, i) =>
            <th key={i}>
                {`FACT ANTICIPO ${i + 1}`}
            </th>
        );
    }
    return null;
};
// <I 86111> ivelasquez 12/03/2021
const renderCeldaPdf = (item, that) => {
    if (item.tipoDocumento.startsWith("F") ||
        item.tipoDocumento.startsWith("B") ||
        item.tipoDocumento.startsWith("C")) {
        return <div>
            {
                <a onClick={() => {
                    that.onClickDescargar({
                        'ruc': item.rucEmisor,
                        'tipoDocumento': item.tipoDocumentoSunat,
                        'serie': item.numeroDocumento.substring(0, 4),
                        'numero': item.numeroDocumento.substring(4, item.numeroDocumento.length),
                        'tipoArchivo': 'PDF'
                    });
                }}
                ><img alt='pdf' className='card-image' src={pdf}/></a>
            }

        </div>
    } else {
        return <div/>
    }
};

const renderCeldaXml = (item, that) => {
    if (item.tipoDocumento.startsWith("F") ||
        item.tipoDocumento.startsWith("B") ||
        item.tipoDocumento.startsWith("C")) {
        return <div>
            {
                <a onClick={() => {
                    that.onClickDescargar({
                        'ruc': item.rucEmisor,
                        'tipoDocumento': item.tipoDocumentoSunat,
                        'serie': item.numeroDocumento.substring(0, 4),
                        'numero': item.numeroDocumento.substring(4, item.numeroDocumento.length),
                        'tipoArchivo': 'XML'
                    })
                }}><img alt='xml' className='card-image' height={32} width={32} src={xml}/></a>
            }
        </div>
    } else {
        return <div/>
    }
};

const renderTable = (registroReponse, that) => {
    if (registroReponse && registroReponse.resultList) {
        return registroReponse.resultList.map((item, index) => (
            <tr key={index}>
                <td>{item.tipoDocumento}</td>
                <td>{item.numeroDocumento}</td>
                <td>{(item.fechaEmision) ? moment(new Date(item.fechaEmision)).format("DD/MM/YYYY") : "-"}</td>
                <td>{renderCeldaXml(item, that)}</td>
                <td>{renderCeldaPdf(item, that)}</td>
            </tr>
        ));
    }
    return <tr>
        <td className='no-before' colSpan={7}>No hay resultados</td>
    </tr>;
};

const KeyCodes = {
    comma: 188,
    enter: 13,
};
const emailRegEx = /^(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+)(([\s]*[;,]+[\s]*(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+))*)$/;
//<F 86111> ivelasquez 12/03/2021

class TablaFacturacion extends Component {
    // <I 86111> ivelasquez 12/03/2021
    static hideMessage() {
        document.getElementById('alert').style.display = 'flex';
        setTimeout(() => {
            if (document.getElementById('alert')) {
                document.getElementById('alert').style.display = 'none';
            }
        }, 5000);
    }
    // <F 86111> ivelasquez 12/03/2021

    constructor(props){
        super(props);
        // <I 86111> ivelasquez 12/03/2021
        this.handleDelete = this.handleDelete.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.handleTagClick = this.handleTagClick.bind(this);
        this.handleDeleteCopia = this.handleDeleteCopia.bind(this);
        this.handleAdditionCopia = this.handleAdditionCopia.bind(this);
        this.handleDragCopia = this.handleDragCopia.bind(this);
        this.enviarCorreoIntern = this.enviarCorreoIntern.bind(this);
        this.onChangeComentarioInput = this.onChangeComentarioInput.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.enviarCorreo = this.enviarCorreo.bind(this);
        /*Inicio Req 92528 ebarboza 27 08 2021 */
        this.copiarPortaPapeles = this.copiarPortaPapeles.bind(this)
        this.copiarPortaPapelesAdd = this.copiarPortaPapelesAdd.bind(this)
        /*Fin Req 92528 ebarboza 27 08 2021 */

        this.validators = correoValidators;
        // <F 86111> ivelasquez 12/03/2021

        this.state ={
            dataTooltip : [],
            isOpen:false,
            // <I 86111> ivelasquez 12/03/2021
            facturaModal: false,
            registroReponse: {itemList: null, numerodePaginas: 0},
            comentario: '',
            enviarPdf: true,
            enviarXml: true,
            tags: [],
            copia: [],
            suggestions: [],
            isFormValided: false,
            muestraLoad: 'none',
            registroCorreo:[],
            correosPedidos: [],
            correosKeys: 1,

            alertErrorOpen: false,
            alertErrorMessage: '',
            alertSuccessOpen: false,
            alertSuccessMessage: '',
            // <F 86111> ivelasquez 12/03/2021
            listaCorreos:props.listaCorreos//Req 92528 ebarboza 30 08 2021
        }
    }
    componentDidMount() {
        /*Inicio Req 92528 ebarboza 30 08 2021 */
        console.log('Lista de Correos:>> ',this.state.listaCorreos)
        let tags = []
        this.state.listaCorreos.map((correo,index) =>{ 
            if(correo){
              tags = [...tags, {id: index, text: correo.correosFichaVenta}]  
            }
                   
        })    
        this.setState({tags:tags})
        /*Fin Req 92528 ebarboza 30 08 2021 */
    }

    closeModal = () =>{
        this.setState({isOpen:false});
        this.setState({facturaModal: false}); // <86111> ivelasquez 12/03/2021
    }
    /*Inicio Req 92528 ebarboza 27 08 2021 */
    copiarPortaPapeles = (e) => {
        if (!emailRegEx.test(e)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }
        let tags = this.state.tags.filter(tag => {return tag.text != e})
        tags = [...tags, {id: tags.length + 1, text: e}]
        this.setState({tags: tags});      
     }

     copiarPortaPapelesAdd = (e) => {
        if (!emailRegEx.test(e)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }
        let copia = this.state.copia.filter(copia => {return copia.text != e})
        copia = [...copia, {id: copia.length + 1, text: e}]
        this.setState({copia: copia});      
     }
    /*Fin Req 92528 ebarboza 27 08 2021 */

    openModal = () =>{
        this.setState({isOpen:true});
    }

    fnSelectPedido = (selectPedido) => {
        this.setState({selectPedido:selectPedido,isOpen:true})
    }
    // <I 86111> ivelasquez 12/03/2021
    fnSelectPedidoModal = (selectPedido, idModal) => {
        this.setState({selectPedido: selectPedido, facturaModal: true, idModal: idModal});

        const array = {
            codCompania: selectPedido.codCia,
            codOficinaRegistral: null,
            codPropietario: null,
            codProveedor: selectPedido.codProv,
            correo: selectPedido.correo,
            desCliente: selectPedido.desClie,
            error: null,
            estadoPedido: selectPedido.estadoPedido,
            fechaCarga: selectPedido.fechaCargaTitulo,
            fechaTitulo: selectPedido.fechaTitulo,
            numChasis: selectPedido.numChasis,
            numPedidoVeh: selectPedido.numPedidoVeh,
            numPlaca: null,
            oficinaRegistral: null,
            situacionInmatriculacion: null,
            titulo: selectPedido.numTitulo
        };

        this.state.registroCorreo = array;

        if (array.correo !== null && array.correo !== "") {
            var correos = array.correo.split(',');

            correos.map(item => {
                var arrayTemp = {id: this.state.correosKeys, text: item};
                this.setState({correosKeys : (this.state.correosKeys + 1)});
                this.state.correosPedidos.push(arrayTemp);
            });
            console.log(this.state.correosPedidos);

            this.setState({tags: this.state.correosPedidos});
        }

        this.props.fetchDetalleFacturas(array)
            .then((result) => {
                if (result.payload.data.estadoTrama === '1') {
                    this.setState({registroReponse: result.payload.data});
                }
            }).catch(() => {
                console.log("error al buscar documentos")
            });
    };

    showError(mensaje) {
        this.setState({
            muestraLoad: 'none',
            iconAlert: 'ion-close-circled',
            colorBackground: '#F56669',
            mensajeAlert: mensaje
        });
    }

    onClickDescargar(params) {
        this.setState({muestraLoad: 'block'});
        this.props.fetchDocumentoDescargar(params).then((result) => {
            if (result.payload.data.estado === 1) {
                const fileName = params.ruc + "-" + params.tipoDocumento + "-" + params.serie + "-" + params.numero + "." + params.tipoArchivo.toLowerCase();
                const contentType = 'application/pdf';
                const b64Data = result.payload.data.fileBase64;
                saveAs(b64Data, contentType, fileName);
                this.setState({muestraLoad: 'none'});
            } else {
                this.setState({muestraLoad: 'none'});
                this.showError(result.payload.data.mensaje)
            }
        }).catch(() => {
            this.setState({muestraLoad: 'none'});
            this.showError("Error interno en el servidor");
        });
    }

    handleDelete(i) {
        this.setState({
            tags: this.state.tags.filter((tag, index) => index !== i),
        });
        let data = {'target': {value: ''}};
        if ((this.state.tags.length - 1) !== 0) {
            data = {'target': {value: 'test'}};
        }
        this.handleInputChange(data, 'tags');
    }

    handleInputBlur(tag) {
        if (!emailRegEx.test(tag)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }

        let {tags} = this.state;
        this.setState({tags: [...tags, {id: tags.length + 1, text: tag}]});
        let data = {'target': {value: tag}};
        this.handleInputChange(data, 'tags');
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags});
    };

    handleTagClick(index) {
        console.log('The tag at index ' + index + ' was clicked');
    };

    handleDeleteCopia(i) {
        this.setState({
            copia: this.state.copia.filter((tag, index) => index !== i),
        });
    };

    handleAdditionCopia(tag) {
        if (!emailRegEx.test(tag)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'copia');
            return;
        }

        let {copia} = this.state;
        this.setState({copia: [...copia, {id: copia.length + 1, text: tag}]});
    };

    handleDragCopia(tag, currPos, newPos) {
        const tags = [...this.state.copia];

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags});
    }

    showAlert = (alertType) => {
        this.setState({ [alertType]: true });
        setTimeout(() => this.setState({ [alertType]: false }), 5000);
    };

    openAlert = (data) => {
        if (data.estadoTrama === '0') {
            this.setState({ alertErrorMessage: data.mensaje });
            this.showAlert('alertErrorOpen');
        } else if (data.estadoTrama === '1') {
            this.setState({ alertSuccessMessage: data.mensaje });
            this.showAlert('alertSuccessOpen');
        } else {
            this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
            this.showAlert('alertErrorOpen');
        }
    };

    enviarCorreo(value) {
        this.setState({
            muestraLoad: 'block',
            closeModal: false
        });

        let destinatario = [];
        let copias = [];
        value.destinatario && value.destinatario.forEach((item) => {
            destinatario.push(item.text);
        });
        value.copia && value.copia.forEach((item) => {
            copias.push(item.text);
        });

        let dataEnviar = [];
        if (value.item && value.item.fechaTitulo) {
            if (value.item.fechaTitulo && value.item.fechaTitulo.toString().indexOf('/') === -1) {
                let fecha = new Date(value.item.fechaTitulo);
                fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY");
                value.item.fechaTitulo = fecha;
            }
            dataEnviar = [value.item];
        } else {
            if (value.item) {
                dataEnviar = [value.item];
                value.item = null;
            } else {
                const {dataRows} = this.state;
                dataRows.forEach((item) => {
                    let fecha = new Date(item.fechaTitulo);
                    fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY");
                    item.fechaTitulo = fecha;
                });
                dataEnviar = dataRows;
            }
        }

        this.props.postInmatriculacionCorreo({
            'items': dataEnviar,
            'destinatario': destinatario,
            'copias': copias,
            'mensaje': value.mensaje,
            'enviarXml': value.enviarXml,
            'enviarPdf': value.enviarPdf,
            'tipoCorreo': 'facturacion',
            'numFichaVtaVeh': value.numFichaVtaVeh
        }).then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                this.closeModal();
                if (document.getElementById('checkBoxAll').checked)
                    document.getElementById('checkBoxAll').click();
                this.props.fnUnSelectedAll();
                this.openAlert(result.payload.data);
                this.setState({registros: [], dataRows: [], selectedID: []});

                this.initPaginacion(0, 0);
                this.setState({selectRow: null});
            } else {
                this.openAlert(result.payload.data);
                this.closeModal();
                this.props.fnUnSelectedAll();
                this.setState({
                    muestraLoad: 'none',
                    selectedID: [],
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor: ${result.payload.data.mensaje}!`
                });
            }
            this.setState({selectRow: null});
        }).catch((error) => {
            this.setState({selectRow: null, selectedID: []});
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: '¡Error interno del servidor!'
            });
        });
    }

    enviarCorreoIntern = () => {
        if (this.state.isFormValided || this.state.tags.length > 0) {
            this.enviarCorreo(
                {
                    mensaje: this.state.comentario,
                    destinatario: this.state.tags,
                    copia: this.state.copia,
                    item: this.state.registroCorreo,
                    enviarXml: this.state.enviarXml,
                    enviarPdf: this.state.enviarPdf,
                    tipoCorreo: 'facturacion',
                    numFichaVtaVeh: this.state.selectPedido.numFichaVtaVeh
                });
            this.setState({tags:[],copia:[],comentario:''});
        }
    };

    onChangeFormValidation = () => {
        this.setState({isFormValided: isFormValid(this.validators)});
    };

    onChangeValue = e => {
        this.setState({[e.target.name]: e.target.checked})
    };

    handleInputChange = (e, field, exclude) => {
        const validator = this.validators[field];
        if(validator) {
            validator.state = (e !== null && !exclude ? e.target.value : '');
            validator.exclude = (typeof(exclude) === 'undefined' || exclude === null ? false : exclude);
            this.onChangeFormValidation();
        }
    };

    onChangeComentarioInput(e) {
        this.setState({comentario: e.target.value});
        this.handleInputChange(e, 'comentario');
    }

    // <F 86111> ivelasquez 12/03/2021

    render () {
        // <I 86111> ivelasquez 12/03/2021
        const {tags, copia, suggestions} = this.state;
        const DefaultClassNames = {
            tag: "pill pill-cyan pillSelct-pills-item ng-binding ng-scope",
        };
        // <F 86111> ivelasquez 12/03/2021

        return (
            <div>
                {
                    this.props.pedidos.length>0 ?(
                        <table className={'table table-hover'}>
                            <thead className='table-head'>
                            <tr>
                                <th>
                                    <div className='checkbox checkbox-inline'>
                                        <label>
                                            <input type='checkbox' id={'checkBoxAll'} onClick={() => this.props.selectAll()} />
                                            <div className='checkbox-skin' />
                                        </label>
                                    </div>
                                </th>
                                <th>Nº Pedido</th>
                                <th>Nº Chasis</th>
								<th>TIPO FACT</th>
                                <th>ESTADO DE CANCELACION</th>
                                <th>CLIENTE FACTURACION</th>
                                <th>CLIENTE PROPIETARIO</th>
                                <th>CLIENTE USUARIO</th>
                                <TablaTh pedidos={this.props.pedidos} />
                            </tr>
                            </thead>
                            <tbody>
                            <TablaTr
                                pedidos={this.props.pedidos}
                                selectCheckPedidos={this.props.selectCheckPedidos}
                                pedidosConCheck={this.props.pedidosConCheck}
                                fnSelectPedido={this.fnSelectPedido}
                                fnSelectPedidoModal={this.fnSelectPedidoModal} // <86111> ivelasquez 12/03/2021
                            />
                            </tbody>
                        </table>
                    ): (
                        <table className={'table table-hover'}>
                            <thead className='table-head'>
                            <tr>
                                <th>
                                    <div className='checkbox checkbox-inline'>
                                        <label>
                                            <input type='checkbox' />
                                            <div className='checkbox-skin' />
                                        </label>
                                    </div>
                                </th>
                                <th>Nº Pedido</th>
                                <th>Nº Chasis</th>
								<th>TIPO FACT</th>
                                <th>ESTADO DE CANCELACION</th>
                                <th>CLIENTE FACTURACION</th>
                                <th>CLIENTE PROPIETARIO</th>
                                <th>CLIENTE USUARIO</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr >
                                <td colSpan='5'><p style={{'text-align':'center'}}> No existe registros !!</p> </td>
                            </tr>
                            </tbody>
                        </table>
                    )
                }

                {
                    this.state.isOpen === true &&
                    <PedidoDetalle
                        isOpen={this.state.isOpen}
                        closeModal = {this.closeModal}
                        pedidos={this.props.pedidos.length > 0? this.props.pedidos.filter(entry => entry.numPedidoVeh===this.state.selectPedido)[0] : {}}
                    />
                }
                {/* <I 86111> ivelasquez 12/03/2021 */}
                {
                    this.state.facturaModal === true && this.state.idModal === 'ver-facturas' &&
                    <div>
                        <Modal modalSize='modal-dialog' title='Detalle de Documentos'
                               closeModal={this.closeModal}
                               isOpen>
                            <div className='steps-container fdvNew-slides'>
                                <div>
                                    <div>
                                        <h4 className='mt-4 mb-2 labelInfo'>N° de
                                            Pedido: {this.state.selectPedido.numPedidoVeh}</h4>
                                        <br/>
                                        <div className='tableWrapper hide-scroll table-180'>
                                            <table className='table table-hover'>
                                                <thead className='table-head'>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Nro Documento</th>
                                                    <th>Fecha Emisión</th>
                                                    <th/>
                                                    <th/>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    this.state.registroReponse.resultList
                                                        ? renderTable(this.state.registroReponse, this)
                                                        : <tr>
                                                            <td className='no-before' colSpan={7}>
                                                                <FadeLoader color={'#F8A14A'} loading/></td>
                                                        </tr>
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                        {
                                            this.state.registroReponse &&
                                            <div
                                                className={this.state.registroReponse.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
                                                <div className='row' style={{marginTop: '20px'}}>
                                                    <div className='col-sm-6 pull-right'>
                                                        <ReactPaginate
                                                            pageCount={this.state.registroReponse.numerodePaginas}
                                                            previousLabel='<<'
                                                            nextLabel='>>'
                                                            containerClassName='pagination pull-right'
                                                            pageClassName='pagination-item'
                                                            activeClassName='pagination-item--active'
                                                            pageLinkClassName='btn-clean pagination-item-btn'
                                                            breakClassName='break pagination-item'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className='modal-actions'> </div>
                                </div>
                            </div>
                        </Modal>
                        <div className='modal extraFilter' role='dialog' data-backdrop='static'
                             style={{zIndex: '2000', display: this.state.muestraLoad}}>
                            <div className='modal-dialog modal-sm' role='document'>
                                <FadeLoader color={'#F8A14A'} loading/>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.facturaModal === true && this.state.idModal === 'enviar-correo' &&
                    <div>
                        <Modal modalSize='modal-dialog' title='Enviar Correo'
                               closeModal={this.closeModal}
                               isOpen>
                            <div>
                                <div className='form-group'>
                                    <label className='labelInfo'> Correos</label>
                                    <ReactTags
                                        tags={tags}
                                        placeholder={"Ingrese un correo"}
                                        suggestions={suggestions}
                                        classNames={DefaultClassNames}
                                        handleDelete={this.handleDelete}
                                        handleInputBlur={this.handleInputBlur}
                                        handleDrag={this.handleDrag}
                                        handleTagClick={this.handleTagClick}
                                        autofocus={true}
                                        handleAddition = {e => this.copiarPortaPapeles(e)} // Req 92528 ebarboza 27 08 2021
                                    />
                                    {this.state.tags.length > 0?null:displayValidationErrors(this.validators, 'tags')}
                                </div>
                                <div className='form-group'>
                                    <label className='labelInfo'> Correos Adicionales</label>
                                    <ReactTags
                                        tags={copia}
                                        suggestions={suggestions}
                                        placeholder={"Ingrese un correo"}
                                        classNames={DefaultClassNames}
                                        handleDelete={this.handleDeleteCopia}
                                        handleInputBlur={this.handleAdditionCopia}
                                        handleDrag={this.handleDragCopia}
                                        handleTagClick={this.handleTagClick}
                                        autofocus={false}
                                        handleAddition = {e => this.copiarPortaPapelesAdd(e)} // Req 92528 ebarboza 27 08 2021
                                    />
                                </div>
                                <div className='form-group'>
                                    <label className='labelInfo'>Texto Correo
                                    </label>
                                    <textarea
                                        className='form-control' value={this.state.comentario}
                                        onChange={this.onChangeComentarioInput}
                                        placeholder='Ingresa tus comentarios acá'
                                    />
                                </div>
                                <div className='form-group'>
                                    <label className='labelInfo'>Adjuntar</label>
                                    <div className='col-md-10'>
                                        <div className='col-md-4'>
                                            <label>XML</label>
                                            <input type="checkbox" disabled={false} readOnly={false} onChange={this.onChangeValue}
                                                   checked={this.state.enviarXml}
                                                   name="enviarXml"
                                            />
                                        </div>
                                        <div className='col-md-4'>
                                            <label>PDF</label>
                                            <input type="checkbox" checked={this.state.enviarPdf} onChange={this.onChangeValue}
                                                   name="enviarPdf"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='modal-actions'>
                                <button className='btn btn-primary pull-right'
                                        onClick={() => this.enviarCorreoIntern()}>Enviar
                                </button>
                            </div>
                        </Modal>
                        <div className='modal extraFilter' role='dialog' data-backdrop='static'
                             style={{zIndex: '2000', display: this.state.muestraLoad}}>
                            <div className='modal-dialog modal-sm' role='document'>
                                <FadeLoader color={'#F8A14A'} loading/>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.alertErrorOpen &&
                    <Alert type='alert-danger' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
                        <p>{this.state.alertErrorMessage}</p>
                    </Alert>
                }
                {
                    this.state.alertSuccessOpen &&
                    <Alert type='alert-success' icon='ion-checkmark-circled' >
                        <p>{this.state.alertSuccessMessage}</p>
                    </Alert>
                }
                {/* <F 86111> ivelasquez 12/03/2021 */}
            </div>
        )
    }
};

TablaFacturacion.defaultProps = {
    pedidos: [],
    // <I 86111> ivelasquez 12/03/2021
    registroReponse: {itemList: [], numerodePaginas: 0},
    muestraLoad: 'none',
    // <F 86111> ivelasquez 12/03/2021
};

// <I 86111> ivelasquez 12/03/2021
function mapStateToProps(state) {
    return {registroReponse: state.registroReponse};
}

export default connect(
    mapStateToProps,
    {
        fetchDocumentoDescargar,
        fetchDetalleFacturas,
        postInmatriculacionCorreo
    })(TablaFacturacion);
// <F 86111> ivelasquez 12/03/2021




// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/TablaFacturacion.js